import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { creditsService } from '../api/services/creditsService';

interface CreditInfo {
  balance: number;
  hasUsedFreeListing: boolean;
  enableFreeListing: boolean;
  isFree: boolean;
}

interface CreditsCardProps {
  refreshTrigger?: number;
}

export default function CreditsCard({ refreshTrigger }: CreditsCardProps) {
  const { t } = useTranslation();
  const [info, setInfo] = useState<CreditInfo | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    creditsService.getBalance()
      .then(setInfo)
      .catch(() => setInfo(null))
      .finally(() => setLoading(false));
  }, [refreshTrigger]);

  if (loading) {
    return (
      <div className="credits-card credits-card--loading">
        <div className="credits-card__shimmer" />
      </div>
    );
  }

  if (!info) return null;

  const canPost = info.balance > 0 || info.isFree;

  return (
    <div className={`credits-card ${canPost ? 'credits-card--ok' : 'credits-card--empty'}`}>
      <div className="credits-card__top">
        <div className="credits-card__icon">
          <i className="bi bi-coin" />
        </div>
        <div className="credits-card__text">
          <span className="credits-card__label">{t('credits_card.available_credits')}</span>
          <span className="credits-card__value">{info.balance}</span>
        </div>
        <Link to="/dashboard/credits" className="credits-card__buy">
          <i className="bi bi-plus-circle me-1" />{t('credits_card.buy_btn')}
        </Link>
      </div>

      {info.isFree && (
        <div className="credits-card__free">
          <i className="bi bi-gift-fill me-1" />
          {t('credits_card.one_free')}
        </div>
      )}

      {!canPost && (
        <div className="credits-card__warn">
          <i className="bi bi-exclamation-triangle me-1" />
          {t('credits_card.no_credits')}
        </div>
      )}
    </div>
  );
}
